<template>
  <main :key="code">
    <div :class="av > 0 ? 'good' : 'bad'">
      <div class="name fx">
        <span>
          <b>{{ title }}</b>
          <P  :class="av > 0 ? 'en' : 'ens'">{{ codeMapEn.get(en) || en }}</P>
        </span>
      </div>
      <div v-if="explain" class="desc">{{ explain }}</div>
      <div class="pointer-container">
        <div  :class="parseFloat(av) > 0 ? 'pointer-values' : 'pointer-value'"
         :style="getPointerStyle()">{{ av }}</div>
        <div class="scale-container">
          <div class="scale-marks">
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">{{ $t('health.status.abnormal') }}</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-4.0</div>
            <div :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-3.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-2.0</div>
            <div :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-1.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">{{ $t('health.status.normal') }}</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+1.0</div>
            <div :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+2.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+3.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+4.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">{{ $t('health.status.excellent') }}</div>
          </div>
          <div class="scale-line"></div>
        </div>
      </div>
    </div>
    <AlgorithmValueNotice />
    <DynamicTrackingCard
      :title="$t('charts.elements.dynamicDataTracking')"
      :data="healthDatas"
      initialValueKey="initialValue"
      finalValueKey="finalValue"
      labelKey="name"
      :showLegend="true"
    />
   
    <div class="horizontal-line"></div>
    <!-- <div class="relation-card">
      <h3>影响身体关联项</h3>
      <div class="relation-items">
        <div 
          v-for="(item, index) in relevancys.children" 
          :key="index" 
          class="relation-item"
          @click="openTissue(index + 1)"
        >
          <div class="item-content">
            <span>{{ item.item_dict_name }}</span>
            <i class="arrow"></i>
          </div>
        </div>
      </div>
    </div> -->
    <SectionView :title="$t('actions.bodyAssociatedItems')">
      <div class="relation-items">
        <div
          v-for="(item, index) in relevancys.children"
          :key="index"
          class="relation-item"
          :class="parseFloat(item.av) < 0 ? 'negative-item' : 'positive-item'"
          @click="openTissue(index + 1)"
        >
          <div class="item-content">
            <span>{{ item.item_dict_name }}</span>
            <img src="../assets/图标-进入.png" alt="" />
          </div>
        </div>
      </div>
    </SectionView>
    <div class="horizontal-line"></div>
    <SectionView :title="$t('actions.nutritionAssociatedItems')">
      <div class="relation-items">
        <div
          v-for="(item, index) in nutritions.children"
          :key="index"
          class="relation-item"
          :class="parseFloat(item.av) < 0 ? 'negative-item' : 'positive-item'"
          @click="openNutrition(index + 1)"
        >
          <div class="item-content">
            <span>{{ item.item_dict_name }}</span>
            <img src="../assets/图标-进入.png" alt="" />
          </div>
        </div>
      </div>
    </SectionView>
    <div class="horizontal-line"></div>
    <ComparisonBarChart
      :title="$t('charts.elements.mainAssociationRatio')"
      :data="activeTabIndex === 0 ? nutritiveRatios : viscusRatios"
      :tabs="[$t('charts.elements.nutritionAssociation'), $t('charts.elements.organAssociation')]"
      :showTabs="true"
      labelKey="name"
      valueKey="value"
      @tab-change="activeTabIndex = $event"
    ></ComparisonBarChart>
    <div class="horizontal-line"></div>

    <!--<list-card title="运动建议" :list="sports"></list-card>-->

    <!-- <tag-card title="影响身体关联项" :list="relations"></tag-card> -->

    <text-card v-if="sports" :title="$t('actions.exerciseRecommendation')" :content="sports"></text-card>
    <div class="horizontal-line"></div>

    <text-card v-if="daily" :title="$t('actions.lifestyleRecommendation')" :content="daily"></text-card>
    <div class="full-health-info-button-container">
        <router-link class="full-health-info-button" :to="{ path: '/overview', query: routeQuery }">{{ $t('actions.viewFullHealthInfo') }}</router-link>
      </div>
    <div class="horizontal-line"></div>

    <diet-card
      v-if="diets.useless.length > 0 || diets.useful.length > 0"
      :useless="diets.useless"
      :useful="diets.useful"
    >
      <template v-slot:action>
        <button
          v-if="showCustomButton"
          class="full-health-info-button full-health-info-button--sub"
          @click="handleCustomSolution"
        >
          {{ $t('actions.customSolution') }}
        </button>
      </template>
    </diet-card>
    <div v-if="codedImageUrl" class="coded-image-card">
      <img :src="codedImageUrl" :alt="$t('common.codedImage')" class="coded-image" />
    </div>
    <div v-if="essentialOil" class="oil-card">
      <div class="oil-card__halo"></div>
      <div class="oil-card__header">
        <div>
          <div class="oil-card__title">{{ essentialOil.name || '精油推荐' }}</div>
          <div class="oil-card__subtitle">{{ essentialOil.project_name || title }}</div>
        </div>
        <div class="oil-card__seal">精油</div>
      </div>

      <div v-if="essentialOil.ratio_list && essentialOil.ratio_list.length" class="oil-ratio-list">
        <div v-for="(item, index) in essentialOil.ratio_list" :key="index" class="oil-ratio">
          <div class="oil-ratio__top">
            <span>{{ item.name }}</span>
            <b>{{ formatOilRatio(item.ratio) }}</b>
          </div>
          <div class="oil-ratio__track">
            <div class="oil-ratio__bar" :style="{ width: getOilRatioWidth(item.ratio) }"></div>
          </div>
        </div>
      </div>

      <div class="oil-info-grid">
        <div v-if="essentialOil.usage_scene" class="oil-info">
          <span>适用场景</span>
          <p>{{ essentialOil.usage_scene }}</p>
        </div>
        <div v-if="essentialOil.suggestion_method" class="oil-info">
          <span>使用方法</span>
          <p>{{ essentialOil.suggestion_method }}</p>
        </div>
      </div>

      <div v-if="essentialOil.suggestion" class="oil-suggestion">
        {{ essentialOil.suggestion }}
      </div>
    </div>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" :title="$t('dialogs.interpretTitle')">
      <span v-for="(item, index) in levels" :key="index"
        ><i :style="{ background: item.color }"></i>{{ item.str }}</span
      >
    </dialog-view>

    <CustomSolutionLoader v-if="showSolutionLoader" @loading-complete="handleLoadingComplete" />
    <CustomSolutionDrawer :visible.sync="showDrawer" @submit="handleDrawerSubmit" @close="handleDrawerClose" />
  </main>
</template>

<script>
import DietCard from "@/components/DietCard";
import TextCard from "@/components/TextCard";
import { getEssentialOilRecommendation, getReportCodedImage, getReportLoopItem } from "../net/api";
import DynamicTrackingCard from "../components/DynamicTrakingCard.vue";
import DialogView from "../components/DialogView";
import SectionView from "@/components/SectionView";
import ComparisonBarChart from "../components/ComparisonBarChart.vue";
import CustomSolutionLoader from "../components/CustomSolutionLoader";
import CustomSolutionDrawer from "../components/CustomSolutionDrawer";
import { isEnglish } from "@/i18n/utils";
import { isWechatEnvironment, navigateToMiniProgram } from "@/utils/wechat";
import { routeLanguageMixin } from "@/utils/routeLanguageHelper";

export default {
  name: "Details",
  mixins: [routeLanguageMixin],
  components: {
    DialogView,
    TextCard,
    DietCard,
    SectionView,
    ComparisonBarChart,
    DynamicTrackingCard,
    CustomSolutionLoader,
    CustomSolutionDrawer
  },

  data() {
    return {
      packageNo: "",
      checkcode: "",
      rand: "",
      activeTabIndex: 0,
      av: " ",
      en:" ",
      relevancys: {
        children: []
      },
      // 添加nutritions初始化（如果也需要的话）
      nutritions: {
        children: []
      },

      code: "",
      title: "",
      color: "#3BA272",
      status: "",

      // 介绍
      explain: "",

      relations: [
        {
          icon: "https://st.aigtfd.com/image/report/qg1p.png",
          name: "免疫力",
        },
        {
          icon: "https://st.aigtfd.com/image/report/qg1p.png",
          name: "免疫力",
        },
        {
          icon: "https://st.aigtfd.com/image/report/qg1p.png",
          name: "免疫力",
        },
        {
          icon: "https://st.aigtfd.com/image/report/qg1p.png",
          name: "免疫力",
        },
        {
          icon: "https://st.aigtfd.com/image/report/qg1p.png",
          name: "免疫力",
        },
        {
          icon: "https://st.aigtfd.com/image/report/qg1p.png",
          name: "免疫力",
        },
      ],
      healthData: [
        { name: "肾", value: -3.2 },
        { name: "情绪", value: -3.0 },
        { name: "睡眠", value: -2.5 },
        { name: "肠益菌", value: -2.1 },
        { name: "心脏", value: -1.5 },
        { name: "脑", value: -0.8 },
        { name: "肝", value: 1.5 },
        { name: "肾", value: -3.2 },
        { name: "情绪", value: -3.0 },
        { name: "睡眠", value: -2.5 },
        { name: "肠益菌", value: -2.1 },
        { name: "心脏", value: -1.5 },
        { name: "脑", value: -0.8 },
        { name: "肝", value: 1.5 },
      ],

      desc: "",
      // 动态跟踪模式
      dynamics: [],
      healthDatas: [],
      // 饮食建议
      diets: {
        useful: [],
        useless: [],
      },
      stackValueKey: {
        one: this.$t ? this.$t('charts.elements.initialValue') : '初值',
        two: this.$t ? this.$t('charts.elements.finalValue') : '终值',
      },
      // 通用态图列表数据关联项
      statusValueKey: {
        av: this.$t ? this.$t('charts.elements.averageValue') : '均值',
        one: this.$t ? this.$t('charts.elements.initialValue') : '初值',
        two: this.$t ? this.$t('charts.elements.finalValue') : '终值',
      },
      // 平均值关联项
      avValueKey: {
        av: this.$t ? this.$t('charts.elements.averageValue') : '均值',
      },
      totalValueKey: {
        shice_value: this.$t ? this.$t('charts.elements.actualValue') : '实测值',
        bili_value: this.$t ? this.$t('charts.elements.standardValue') : '标准',
      },
      // 主要内脏关联比例图
      viscusRatios: [],
      // 主要营养素关联比例图
      nutritiveRatios: [],
      // 主要内脏平均值状态图
      viscusStatus: [],
      // 主要营养素平均值状态图
      nutritionStatus: [],

      // 运动建议
      sports: "",
      // 起居建议
      daily: "",

      // 报告等级列表
      levels: [],

      // 解读说明弹窗
      interpret: false,
      legends: [
        { name: this.$t ? this.$t('charts.elements.actualValue') : '实测值', colors: [] },
        { name: this.$t ? this.$t('charts.elements.standardValue') : '标准', colors: ["#C3C2C2"] },
      ],
      codeMapEn: new Map([
        ['Internal organs’ function', 'Overworked'],
        ['Allergic constitution', 'Allergy-Prone']
      ]),
      codedImageUrl: "",
      essentialOil: null,
      showSolutionLoader: false,
      showDrawer: false,
      userFormData: null,
      hasPro: false,
      hasSchemeAssess: false,
      hasCustomSolution: false,
      isThirdParty: false,
    };
  },

  computed: {
    hideEntryActions() {
      return this.$store.getters.isThirdPartyMode;
    },

    showCustomButton() {
      return !this.hideEntryActions && (this.hasSchemeAssess || this.hasCustomSolution);
    },

    // 基础参数数据
    query() {
      const baseQuery = {
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      };

      const currentQuery = this.$route.query || {};
      if (currentQuery.pro !== undefined) {
        baseQuery.pro = currentQuery.pro;
      }
      if (currentQuery.schemeAssess !== undefined) {
        baseQuery.schemeAssess = currentQuery.schemeAssess;
      }
      if (currentQuery.customSolution !== undefined) {
        baseQuery.customSolution = currentQuery.customSolution;
      }
      if (currentQuery.hideShare !== undefined) {
        baseQuery.hideShare = currentQuery.hideShare;
      }
      if (currentQuery.isThirdParty !== undefined) {
        baseQuery.isThirdParty = currentQuery.isThirdParty;
      }
      if (currentQuery.source !== undefined) {
        baseQuery.source = currentQuery.source;
      }
      
      // 如果是英文模式，添加语言参数
      if (isEnglish()) {
        baseQuery.lang = 'en';
      }
      
      return baseQuery;
    },
  },

  created() {
    const query = this.$router.currentRoute.query;
    this.update(query);
    this.syncPageData(query);
  },

  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },

  beforeRouteUpdate(to, from, next) {
    this.$loading.start();
    const query = to.query;
    this.syncPageData(query, () => {
      this.update(query);
      // 滚动条滚动到顶部
      (document.scrollingElement || document.body).scrollTop = 0;
      this.$loading.stop();
    });
    next();
  },

  methods: {
    update(query) {
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;
      this.av = query.av;
      this.title = query.title;
      this.color = query.color;
      this.code = query.code;
      this.hasPro = query.pro === '1';
      this.hasSchemeAssess = query.schemeAssess === '1';
      this.hasCustomSolution = query.customSolution === '1';
      this.isThirdParty = query.isThirdParty === '1';
    },
    normalizeComplianceText(text) {
      if (!text) {
        return "";
      }
      return String(text)
        .replace(/未见异常风险/g, "暂无重点关注项")
        .replace(/异常/g, "偏低关注")
        .replace(/正常/g, "参考区间")
        .replace(/优异/g, "偏高关注")
        .replace(/严重缺乏/g, "建议关注项")
        .replace(/功能不足/g, "相关状态建议关注")
        .replace(/供血压力增大/g, "建议结合饮食、作息、运动综合管理")
        .replace(/供血不足/g, "建议结合饮食、作息、运动综合管理");
    },
    // 计算指针位置
    // 计算指针位置
   getPointerStyle() {
  const min = -5.0;
  const max = 5.0;
  const value = parseFloat(this.av) || 0;
  const clampedValue = Math.max(min, Math.min(max, value));
  const totalRange = max - min;
  const percent = ((clampedValue - min) / totalRange) * 100;

  return {
    left: `${percent}%`,
    transform: "translateX(-50%)",
  };
},

    // 获取左侧百分比

    resolveCodedImageUrl(data) {
      if (!data) return "";

      if (typeof data === "string") {
        return data;
      }

      return data.imageUrl || data.image_url || data.url || data.codedImage || data.coded_image || "";
    },

    fetchCodedImage(code) {
      if (!code) {
        this.codedImageUrl = "";
        return;
      }

      getReportCodedImage(code)
        .then((data) => {
          this.codedImageUrl = this.resolveCodedImageUrl(data);
        })
        .catch((error) => {
          console.error("获取编码图片失败:", error);
          this.codedImageUrl = "";
        });
    },

    fetchEssentialOilRecommendation(code) {
      if (!code) {
        this.essentialOil = null;
        return;
      }

      getEssentialOilRecommendation(code)
        .then((data) => {
          const ratioList = Array.isArray(data && data.ratio_list) ? data.ratio_list : [];
          const hasContent = data && (
            data.name ||
            data.project_name ||
            ratioList.length > 0 ||
            data.usage_scene ||
            data.suggestion_method ||
            data.suggestion
          );

          this.essentialOil = hasContent ? {
            ...data,
            ratio_list: ratioList
          } : null;
        })
        .catch((error) => {
          console.error("获取精油推荐失败:", error);
          this.essentialOil = null;
        });
    },

    formatOilRatio(ratio) {
      const value = Number(ratio);
      if (Number.isNaN(value)) {
        return "";
      }
      return `${value}%`;
    },

    getOilRatioWidth(ratio) {
      const value = Number(ratio);
      if (Number.isNaN(value)) {
        return "0%";
      }
      return `${Math.max(0, Math.min(100, value))}%`;
    },

    async handleCustomSolution() {
      if (this.isThirdParty) {
        this.handleThirdPartyReturn();
        return;
      }

      if (this.hasSchemeAssess) {
        await this.navigateToSchemeAssessBridge();
        return;
      }

      this.showDrawer = true;
    },

    navigateToSchemeAssessBridge() {
      if (!this.packageNo) {
        this.showErrorMessage('缺少报告编号，请刷新后重试');
        return Promise.reject(new Error('缺少报告编号'));
      }

      if (typeof window.wx === 'undefined' || !window.wx.miniProgram) {
        this.showErrorMessage('请在小程序中打开此页面');
        return Promise.reject(new Error('不在小程序环境'));
      }

      const targetUrl = `/pages/shop/schemeAssessBridge/schemeAssessBridge?packageNo=${encodeURIComponent(this.packageNo)}`;

      return new Promise((resolve, reject) => {
        window.wx.miniProgram.navigateTo({
          url: targetUrl,
          success: resolve,
          fail: (err) => {
            this.showErrorMessage('跳转失败，请稍后重试');
            reject(err);
          }
        });
      });
    },

    handleThirdPartyReturn() {
      if (typeof window.wx === 'undefined') {
        alert('错误：不在微信环境中，无法返回');
        return;
      }

      if (!window.wx.miniProgram) {
        alert('错误：不在小程序环境中，无法返回');
        return;
      }

      const env = window.__wxjs_environment;
      if (env !== 'miniprogram') {
        alert('错误：当前不在小程序web-view中，无法返回');
        return;
      }

      const reportData = {
        status: 'success',
        reportId: this.packageNo || '',
        reportUrl: window.location.href,
        checkTime: '',
        customerName: ''
      };

      try {
        window.wx.miniProgram.postMessage({
          data: {
            action: 'thirdPartyReturn',
            data: reportData
          }
        });

        setTimeout(() => {
          window.wx.miniProgram.navigateBack();
        }, 500);
      } catch (err) {
        alert('返回失败：' + err.message);
      }
    },

    isFlutterApp() {
      return window.flutter_inappwebview && typeof window.flutter_inappwebview.callHandler === 'function';
    },

    async handleDrawerSubmit(formData) {
      this.userFormData = formData;
      this.showDrawer = false;

      try {
        this.showSolutionLoader = true;

        if (this.isFlutterApp()) {
          await this.navigateToFlutterApp(formData.selectedKeys);
        }
      } catch (error) {
        this.showSolutionLoader = false;
        this.showErrorMessage('提交失败，请稍后重试');
      }
    },

    handleDrawerClose() {
    },

    async handleLoadingComplete() {
      try {
        if (this.isFlutterApp()) {
          this.showSolutionLoader = false;
          return;
        }

        if (!this.isWechatEnvironment()) {
          this.showSolutionLoader = false;
          this.showErrorMessage('请在微信中打开此页面');
          return;
        }

        await this.navigateToMiniProgram();
      } catch (error) {
        this.showSolutionLoader = false;
        this.showErrorMessage('跳转失败，请稍后重试');
      }
    },

    isWechatEnvironment() {
      return isWechatEnvironment();
    },

    async navigateToFlutterApp(questionnaireKeys) {
      try {
        await window.flutter_inappwebview.callHandler('navigateToEvaluationPlan', {
          packageNo: this.packageNo,
          questionnaire: questionnaireKeys || []
        });

        this.showSolutionLoader = false;
      } catch (error) {
        this.showSolutionLoader = false;
        this.showErrorMessage('跳转失败，请稍后重试');
        throw error;
      }
    },

    async navigateToMiniProgram() {
      const selectedKeys = this.userFormData?.selectedKeys || [];
      const questionnaireParam = encodeURIComponent(JSON.stringify(selectedKeys));
      const miniProgramData = {
        serial_number: this.packageNo,
        timestamp: Date.now(),
        source: 'h5_custom_solution',
        userInfo: this.userFormData
      };

      await navigateToMiniProgram({
        appId: 'wx8c05eb024a5db14a',
        path: `/pages/shop/evaluationPlan/evaluationPlan?packageNo=${this.packageNo}&questionnaire=${questionnaireParam}&pro=1`,
        extraData: miniProgramData,
        envVersion: 'release'
      });
    },

    showErrorMessage(message) {
      if (this.$toast) {
        this.$toast(message);
      } else {
        alert(message);
      }
    },

    handleVisibilityChange() {
      if (document.hidden && this.showSolutionLoader) {
        setTimeout(() => {
          this.showSolutionLoader = false;
        }, 1000);
      }
    },

    // 同步页面数据
    syncPageData(query, callback) {
      // 获取报告数据
      getReportLoopItem({
        packageNo: query.packageNo,
        rand: query.rand,
        checkcode: query.checkcode,
        system_code: query.code,
      }).then((data) => {
        this.levels = data.colorData;
        // 处理状态
        for (let level of this.levels) {
          if (level.color === this.color) {
            this.status = level.str;
            break;
          }
        }

        this.desc =
          data.show_liuduan !== "未见异常风险" ? this.normalizeComplianceText(data.show_liuduan) : null;
        this.en = data.item_dict_name_en;
        this.explain = data.item_explain || '';
        this.dynamics = data.show_dongtai;
        this.relevancys = data.show_neizangguanlian;
        this.nutritions = data.show_yingyangguanlian;
        this.diets.useful = data.show_yinshijianyi.tolerantFood;
        this.diets.useless = data.show_yinshijianyi.noTolerantFood;
        // this.viscusRatios = data.show_neizangbili_new;
        this.nutritiveRatios = data.show_yingyangbili_new;
        this.viscusStatus = data.show_neizangzhuangtai;
        this.nutritionStatus = data.show_yingyangzhuangtai;
        this.sports = data.show_yundongjianyi;
        this.daily = data.show_qijujianyi;
        this.fetchCodedImage(query.code);
        this.fetchEssentialOilRecommendation(query.code);
        if (this.dynamics && this.dynamics.length > 0) {
          this.healthDatas = this.dynamics.map((item) => ({
            initialValue: item.one,
            finalValue: item.two,
            name: item.time,
            av: item.av,
          }));
        }
        if (
          data.show_yingyangbili_new &&
          data.show_yingyangbili_new.length > 0
        ) {
          this.nutritiveRatios = data.show_yingyangbili_new.map((item) => ({
            name: item.item_dict_name_simple|| "",
            shice_value: item.shice_value || "0%",
            bili_value: item.bili_value || "0%",
            av:item.av
          }));
        }
        if (data.show_neizangbili_new && data.show_neizangbili_new.length > 0) {
          this.viscusRatios = data.show_neizangbili_new.map((item) => ({
            name: item.item_dict_name || "",
            value: parseFloat(item.av || 0),
          }));
        }

        if (callback) callback();
      });
    },

    // 跳转至身体关联项
    openTissue(index) {
      let row =
        index === 0 ? this.relevancys : this.relevancys.children[index - 1];
      this.replaceWithLanguage({
        path: "/details",
        query: {
          av:row.av,
          code: row.system_code,
          title: row.item_dict_name,
          color: row.color,
          ...this.query,
        },
      });
    },

    // 跳转至营养素关联项
    openNutrition(index) {
      let row =
        index === 0 ? this.nutritions : this.nutritions.children[index - 1];
      this.navigateWithLanguage({
        path: "/nutrition",
        query: {
          code: row.system_code,
          title: row.item_dict_name,
          color: row.color,
          av:row.av,
          ...this.query,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  padding: 0;
  padding-bottom: 70px;
  .bad {
    background-color: #ff5c4d;
    min-height: 168px;
  }
  .good {
    background-color: #003cbf;
    min-height: 168px;
  }
  .name {
    position: relative;
    padding-top: 30px;
    text-align: center;
    font-weight: 600;
font-size: 42px;
color: #FFFFFF;
line-height: 22px;
text-align: center;
font-style: normal;
text-transform: none;

    span {
      position: relative;
      padding: 0 10px;
    }

    b {
      position: relative;
      color: #ffffff;
      line-height: 70px;
      font-weight: 500;
      text-align: center;
    }
  }
  .en{
    font-weight: 400;
font-size: 24px;
color: #CBE2FF;
line-height: 22px;
text-align: center;
font-style: normal;
text-transform: none;
margin-bottom: 18px;
  }
  .ens{
    color: #FFD5D5;
    font-weight: 400;
font-size: 24px;
line-height: 22px;
text-align: center;
font-style: normal;
text-transform: none;
margin-top: 8px;
margin-bottom: 18px;
  }
  .desc {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
    line-height: 1.5;
    text-align: left;
    font-style: normal;
    margin-left: 64px;
    letter-spacing: 0.5px; 
    margin-right: 64px;
    margin-top: 10px;
    margin-bottom: 18px;
    text-transform: none;
    display: block;
    visibility: visible;
  }

  .pointer-container {
    position: relative;
  width: 100%; /* 或固定宽度，如600px */
  box-sizing: border-box;
  margin: 0 auto;

    .pointer-value {
      background-color: #fff;
      color: #ff5c4d;
      font-size: 24px;
      font-weight: bold;
      width: 80px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      position: absolute;
      bottom: 54px;
      transform: translateX(-50%);
      z-index: 2;

      &:after {
        content: "";
        position: absolute;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;

        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #fff;
      }
    }

    .scale-container {
      position: relative;
      height: 80px;
      margin-top: 50px;

      .scale-line {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        background-color: rgba(219, 201, 201, 0.3);
      }

      .scale-marks {
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 10px;
        padding:0 ; /* 确保无内边距影响位置计算 */
        left: 0;
        right: 0;

        .scale-mark {
          width: 100%; /* 平均分配宽度 */
          font-size: 23px;
          position: relative;
          color: #FFE8E5;

          &:before {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 12px;
            background-color: #ffe8e6;
          }
        }
        .scale-markss {
          width: 100%; /* 平均分配宽度 */
          font-size: 23px;
          position: relative;
          color: #D0DEFF;

          &:before {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 12px;
            background-color: #ffe8e6;
          }
        }
      }

      .pointer {
        position: absolute;
        bottom: 0;
        width: 4px;
        height: 20px;
        background-color: #fff;
        transform: translateX(-50%);
        z-index: 1;
      }

      .left-percent {
        position: absolute;
        bottom: 30px;
        left: 0;
        font-size: 14px;
      }

      .right-percent {
        position: absolute;
        bottom: 30px;
        right: 0;
        font-size: 14px;
      }
    }
  }
  .relation-items {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 0 20px 20px;

    .relation-item {
      background-color: #FDFDFD;
      border-radius: 6px;
      overflow: hidden;
      width: 200px;
      margin-right:10px;
      margin-top: 10px;
      margin-bottom: 10px;
          height: 76px;
      position: relative;
      border: 1px solid #E9E9E9;
      &.negative-item {
        color: #FF5C4D;
        background-color: #FFFAFA;
        border: 1px solid #FFDEDE;
      }
      
      &.positive-item {
        color:#003CBF;
        background-color: #F4F9FF;
        border: 1px solid #DCE2FF;
      }

      .item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        min-height: 20px;

        span {
          font-weight: 500;
          font-size: 27px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        img {
          width: 30px;
          height: 30px; /* 图标高度，可根据实际调整 */
          object-fit: contain; /* 保持图片比例，避免拉伸变形 */
        }
      }

      // 第二个项目（肝功能）使用默认黑色
    }
  }
  .horizontal-line {
    width: 100%;
  height: 1px;
  border-top: 2px dashed #DFDFDF; /* 将实线背景改为虚线边框 */
  background-color: transparent; /* 移除背景色 */
  margin: 25px 0;
  }
  .full-health-info-button-container {
    padding: 20px 30px;
    margin: 20px 0;
  }
  
  .full-health-info-button {
    width: 100%;
    height: 90px;
    background-color: #0052D9;
    color: white;
    border: none;
    border-radius: 45px;
    font-size: 32px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    cursor: pointer;
  }
  .full-health-info-button--sub {
    background-color: #1961FF;
  }
  .pointer-values {
  background-color: #fff;
  color: #2026e3;
  font-size: 24px;
  font-weight: bold;
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  position: absolute;
  margin-bottom: 10px;
  transform: translateX(-50%);
  z-index: 2;
  &:after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
  }
}

.coded-image-card {
  margin: 20px 20px 30px;
  border-radius: 24px;
  overflow: hidden;
  background: #f5f7ff;
}

.coded-image {
  display: block;
  width: 100%;
  height: auto;
}

.oil-card {
  position: relative;
  margin: 0 20px 34px;
  padding: 28px 24px;
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(180deg, #f4f9ff 0%, #ffffff 100%);
}

.oil-card__halo {
  display: none;
}

.oil-card__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 26px;
}

.oil-card__title {
  font-weight: 600;
  font-size: 34px;
  color: #00133d;
  line-height: 1.35;
}

.oil-card__subtitle {
  margin-top: 8px;
  font-weight: 400;
  font-size: 24px;
  color: #858abb;
}

.oil-card__seal {
  flex: 0 0 auto;
  min-width: 78px;
  height: 48px;
  padding: 0 18px;
  border: 1px solid #dce2ff;
  border-radius: 24px;
  background: #ffffff;
  color: #003cbf;
  font-weight: 500;
  font-size: 24px;
  line-height: 48px;
  text-align: center;
}

.oil-ratio-list {
  position: relative;
  display: grid;
  gap: 20px;
  padding: 24px;
  border: 1px solid #e9e9e9;
  border-radius: 18px;
  background: #ffffff;
}

.oil-ratio__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 27px;
  color: #00133d;
}

.oil-ratio__top b {
  color: #003cbf;
  font-size: 27px;
}

.oil-ratio__track {
  width: 100%;
  height: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf2ff;
}

.oil-ratio__bar {
  height: 100%;
  border-radius: inherit;
  background: #003cbf;
}

.oil-info-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin-top: 24px;
}

.oil-info {
  padding: 22px 24px;
  border: 1px solid #e9e9e9;
  border-radius: 18px;
  background: #ffffff;
}

.oil-info span {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 24px;
  color: #003cbf;
}

.oil-info p {
  margin: 0;
  font-weight: 400;
  font-size: 26px;
  color: #444b66;
  line-height: 1.62;
}

.oil-suggestion {
  position: relative;
  margin-top: 20px;
  padding: 22px 24px;
  border-radius: 18px;
  background: #f4f9ff;
  color: #00133d;
  font-size: 26px;
  line-height: 1.62;
}
}
</style>
